import React, { useState } from "react";
import QRWithLogo from "./QRWithLogo";

function App() {
  const [link, setLink] = useState("");
  const [logo, setLogo] = useState(null);
  const [showQR, setShowQR] = useState(false);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => setLogo(ev.target.result);
      reader.readAsDataURL(file);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%)",
        fontFamily: "Segoe UI, Arial, sans-serif",
        padding: 16,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          padding: 32,
          maxWidth: 350,
          width: "100%",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#3b82f6", marginBottom: 24 }}>Generate QR Code</h2>
        <input
          type="text"
          placeholder="Nhập link..."
          value={link}
          onChange={(e) => setLink(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            borderRadius: 8,
            border: "1px solid #d1d5db",
            marginBottom: 16,
            fontSize: 16,
            outline: "none",
            boxSizing: "border-box",
          }}
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleLogoChange}
          style={{
            marginBottom: 16,
            width: "100%",
            fontSize: 15,
          }}
        />
        <button
          style={{
            width: "100%",
            padding: 12,
            background: "#3b82f6",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            cursor: link ? "pointer" : "not-allowed",
            marginBottom: 16,
            transition: "background 0.2s",
            boxShadow: link
              ? "0 2px 8px rgba(59,130,246,0.12)"
              : "none",
          }}
          onClick={() => setShowQR(true)}
          disabled={!link}
        >
          Tạo QR
        </button>
        {logo && (
          <div style={{ marginBottom: 16 }}>
            <span
              style={{
                fontSize: 13,
                color: "#6b7280",
                display: "block",
                marginBottom: 4,
              }}
            >
              Logo đã chọn:
            </span>
            <img
              src={logo}
              alt="Logo"
              style={{
                maxWidth: 60,
                maxHeight: 60,
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                background: "#f3f4f6",
                objectFit: "contain",
              }}
            />
          </div>
        )}
        {showQR && <QRWithLogo value={link} logo={logo} />}
      </div>
      <div style={{ marginTop: 32, color: "#94a3b8", fontSize: 13 }}>
        © {new Date().getFullYear()} QR Generator
      </div>
    </div>
  );
}

export default App;